import { useHeadingStructureContext } from '@context/heading-structure-context';
import { StyledContent } from '@styles/app.styles';
import { StyledDescription } from '@styles/heading-structure.styles';
import { __ } from '@utils/i18n';
import HeadingStructureHeadingTree from './components/heading-tree';
import HeadingStructureHeadingTreeEmpty from './components/heading-tree-empty';

const HeadingStructureLayout = () => {
	const { isLoading, pageHeadings } = useHeadingStructureContext();

	if (!pageHeadings.length && !isLoading) {
		return <HeadingStructureHeadingTreeEmpty />;
	}

	return (
		<StyledContent>
			<StyledDescription as="p" variant="body2">
				{__(
					'Ensure your page has one clear H1 and a consistent heading structure for accessibility and SEO',
				)}
			</StyledDescription>

			<HeadingStructureHeadingTree />
		</StyledContent>
	);
};

export default HeadingStructureLayout;
